export const fmtTime = (t) => {
  if (!t) return '';
  const [h, m] = t.split(':').map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, '0')} ${h >= 12 ? 'PM' : 'AM'}`;
};

export const fmtTimeRange = (e) => [fmtTime(e.start_time), fmtTime(e.end_time)].filter(Boolean).join(' – ');

export const parseDay = (s) => {
  const [y, m, d] = (s || '').split('-').map(Number);
  return y && m && d ? new Date(y, m - 1, d) : null;
};

export const fmtLongDate = (s) => {
  const d = parseDay(s);
  return d ? d.toLocaleDateString('en-CA', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }) : s;
};

export const isPast = (s) => {
  const d = parseDay(s);
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return d ? d < today : false;
};

export const money = (v) => (!v ? 'Free' : `$${Number(v).toFixed(2).replace(/\.00$/, '')}`);

export const priceSummary = (e) => {
  const types = e?.ticket_types || [];
  if (!types.length) return 'Free';
  const member = types.find((t) => t.members_only);
  const paid = types.filter((t) => !t.members_only && t.price > 0).map((t) => t.price);
  const min = paid.length ? Math.min(...paid) : 0;
  if (member && !member.price && min) return `Free for members · ${money(min)}`;
  if (!paid.length && types.every((t) => !t.price)) return 'Free';
  const max = Math.max(...types.map((t) => t.price || 0));
  return min && max > min ? `${money(min)} – ${money(max)}` : money(max);
};
